

































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { upload } from '@/common/util/ossUploadService';
import { formRules } from '@/common/util/validator';

@Component({
    components: {},
})
export default class ImagesUpload extends Vue {
    @Prop({
        default: [],
    })
    public data;

    @Prop({
        default: false,
    })
    public disable;

    dialogImageUrl = '';
    dialogVisible = false;
    handleRemove(file, fileList) {
        console.log(file, fileList);
        this.$emit('deleteImage', file.name, file.uid, file.url);
    }
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    }
    mounted() {
        if (this.data != '') {
            this.src = this.data;
            this.isShow = true;
        }
    }

    public $refs: {
        imageUploadInput: HTMLFormElement;
    };

    public isShow = false;
    public file;
    public src;
    public imgName = '';
    public async handleUpload(param, fileList) {
        console.log('toupload-->', param);
        const res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            console.log('chengggonel-->', param.file.name, url, this.data, this.$refs.imageUploadInput.fileList);
            this.$emit('setImage', param.file.name, url, param.file.uid);
        } else {
            this.$message.warning('图片上传失败!');
        }
    }
    public async changeFile(e) {
        if (e.target.files[0]) {
            this.imgName = e.target.files[0].name;
            let imgType = this.imgName.split('.').pop();
            let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
            this.file = e.target.files[0];
            this.src = URL.createObjectURL(e.target.files[0]);

            if (allowType.indexOf(imgType.toLowerCase()) === -1) {
                this.$alert('不支持该文件类型').then((e) => {
                    this.src = null;
                    this.isShow = false;
                    this.$refs.imageUploadInput.value = null;
                });
                return;
            }
            if (e.target.files[0].size > 5 * 1024 * 1024) {
                this.$alert('文件大小不能超过5M').then((e) => {
                    this.src = null;
                    this.isShow = false;
                    this.$refs.imageUploadInput.value = null;
                });
                return;
            }
            this.isShow = true;
            this.upload();
        }
        e.target.value = '';
    }

    public setData(data) {
        this.src = data;
        this.isShow = true;
        console.log('this.src' + this.src);
    }

    public deleteSrc() {
        this.src = null;
        this.isShow = false;
        this.$emit('deleteImage');
    }

    public async upload() {
        const res = await upload(this.file, this.imgName);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            this.$emit('setImage', this.imgName, url);
        } else {
            this.$message.warning('图片上传失败!');
        }
    }

    public beforeAvatarUpload(file) {
        let imgType = file.name.split('.').pop();
        let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
        //console.log('type-->',file,imgType);
        if (allowType.indexOf(imgType.toLowerCase()) === -1) {
            this.$alert('不支持该文件类型').then((e) => {});
            return false;
        }
    }
}
